import { useEffect } from 'react';
import ContainerHero from './components/ContainerHero';
import ContainerFeatures from './components/ContainerFeatures';
import ContainerBenefits from './components/ContainerBenefits';
import ContainerDocumentation from './components/ContainerDocumentation';
import ContainerPricing from './components/ContainerPricing';
import ContainerCTA from './components/ContainerCTA';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

const PdfRestContainerPage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = 'pdfRest API Toolkit Container - 企业级PDF处理容器解决方案 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'pdfRest API Toolkit Container提供容器化的PDF REST API工具包，支持云端部署和本地部署，提供灵活的PDF处理接口，适用于微服务架构和云原生应用。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'pdfRest,PDF API,容器化,Docker,Kubernetes,微服务,云原生,REST API');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/pdf-rest-container`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "pdfRest API Toolkit Container",
      "applicationCategory": "DeveloperApplication",
      "description": "容器化的PDF REST API工具包，提供灵活的PDF处理接口，支持云端部署和本地部署",
      "url": `${siteUrl}/pdf-rest-container`,
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "CNY",
        "price": "按需定制"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "43"
      },
      "provider": {
        "@type": "Organization",
        "name": "星允信息科技有限公司"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ContainerHero />
        <ContainerFeatures />
        <ContainerBenefits />
        <ContainerDocumentation />
        <ContainerPricing />
        <ContainerCTA />
      </main>
      <Footer />
    </div>
  );
};

export default PdfRestContainerPage;
